import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { AxiosResponse } from 'axios';

import Thumbnail from '../Thumbnail';
import { DragNDropSpeechBubble } from './DragNDropSpeechBubble';
import { DragDropContainer } from '../../shared';

import { ImageFileUploading, OptionalData } from '../../utils/upload';

import { MediaType } from '../../types/enums/mediatype.enum';

import { Media } from '../../types/mediaTypes';

export type AllowedMediaTypes =
    | MediaType.IAP_IMAGE
    | MediaType.TAB_THUMBNAIL
    | MediaType.WIDE_THUMBNAIL
    | MediaType.THUMBNAIL;

type PackMediaSectionProps = {
    type: AllowedMediaTypes;
    items: (Media | (ImageFileUploading & { id?: number }))[];
    onMediasSelected: (
        type: MediaType,
        items: ImageFileUploading[],
        optionalData: OptionalData,
    ) => void;
    onMediasWasUploaded: (
        type: MediaType,
        file: File,
        res: AxiosResponse<{ uploaded: Media }>,
    ) => void;
    onMediaDelete: (index: number, type: MediaType) => void;
    onMediaDragEnd: (result: {
        source: { index: number; droppableId: MediaType };
        destination: { index: number };
    }) => void;
    header: string;
    onProcessingComplete?: (media: Media) => void;
    onProcessingError?: (mediaId: number) => void;
};

export const PackMediaSection = (props: PackMediaSectionProps) => {
    const {
        type,
        items,
        onMediasSelected,
        onMediasWasUploaded,
        onMediaDelete,
        onMediaDragEnd,
        header,
        onProcessingComplete,
        onProcessingError,
    } = props;

    return (
        <DndProvider backend={HTML5Backend}>
            <DragDropContainer
                type={type}
                onMediasSelected={onMediasSelected}
                onMediasWasUploaded={onMediasWasUploaded}
            >
                <h3>{header}</h3>
                {items.length ? <DragNDropSpeechBubble /> : null}
                <Thumbnail
                    id={type}
                    isMultiple={false}
                    type={type}
                    items={items}
                    onDelete={onMediaDelete}
                    onSelect={onMediasSelected}
                    onUpload={onMediasWasUploaded}
                    onDragPhotoEnd={onMediaDragEnd}
                    onProcessingComplete={onProcessingComplete}
                    onProcessingError={onProcessingError}
                />
            </DragDropContainer>
        </DndProvider>
    );
};
